import React, {PureComponent} from 'react';
import * as ReactGA from '../../GA';
import {Link} from 'react-router-dom';
import TranslatedText from '../../atoms/TranslatedText';
import {ROUTES} from '../../routes';
import backIcon from '../../assets/icon-arrow.svg';
import rock from './impact-rock.png';
import ball from './impact-ball.png';
import i18n from '../../locales/i18n';
import Apng from '../../atoms/Apng';

import './HighDefinitionOpticsImpact.css';

export default class HighDefinitionOpticsImpact extends PureComponent {
    componentDidMount() {
        ReactGA.pageview(
            `${i18n.language}/HighDefinitionOptics/ImpactProtection`
        );
    }

    render() {
        return (
            <article className="HighDefinitionOpticsImpact">
                <div className="HighDefinitionOpticsImpact-top">
                    <h3 className="top-title">
                        <TranslatedText tag="high_definition_optics.impact_protection.title" />
                    </h3>
                    <div className="top-subtitle">
                        <TranslatedText tag="high_definition_optics.impact_protection.description" />
                    </div>
                </div>
                <div className="HighDefinitionOpticsImpact-center">
                    <div className="HighDefinitionOpticsImpact-half">
                        <div className="HighDefinitionOpticsImpact-label">
                            <TranslatedText tag="high_definition_optics.impact_protection.velocity_label" />
                        </div>
                        <Apng
                            className="HighDefinitionOpticsImpact-rock"
                            src={rock}
                            alt=""
                        />
                        <div className="HighDefinitionOpticsImpact-link">
                            <Link
                                to={
                                    ROUTES.HIGH_DEFINITION_OPTICS_IMPACT_VELOCITY
                                }>
                                <TranslatedText tag="high_definition_optics.impact_protection.velocity_link" />
                                <div className="HighDefinitionOpticsImpact-icon">
                                    <img src={backIcon} alt="" />
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="HighDefinitionOpticsImpact-half">
                        <div className="HighDefinitionOpticsImpact-label HighDefinitionOpticsImpact-label--bottom">
                            <TranslatedText tag="high_definition_optics.impact_protection.mass_label" />
                        </div>
                        <Apng
                            className="HighDefinitionOpticsImpact-ball"
                            src={ball}
                            alt=""
                        />
                        <div className="HighDefinitionOpticsImpact-link">
                            <Link
                                to={ROUTES.HIGH_DEFINITION_OPTICS_IMPACT_MASS}>
                                <TranslatedText tag="high_definition_optics.impact_protection.mass_link" />
                                <div className="HighDefinitionOpticsImpact-icon">
                                    <img src={backIcon} alt="" />
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/highDefinitionOptics/HighDefinitionOpticsImpact.js